import { WrapMdMarginBottom } from "App/global-style";
import { FormText } from "Components/Features/CheckPrice/Products/productInterfaces";
import { ContactUsAlert } from "Components/Form/Alert";
import { Input } from "Components/Form/Input";
import { InputMode } from "Components/Form/Input/inputTypes";
import { TextLanguage } from "Store/texts/interfaces";
import { getError } from "Utils/productUtils";
import { FormikProps } from "formik";
import React from "react";
import { isGrossAreaInvalid } from "../../cabinConditions";
import { CabinProductIntroFormValues } from "../cabinProductIntroInterfaces";
interface Props {
  formProps: FormikProps<CabinProductIntroFormValues>;
  productText: FormText;
  lang: TextLanguage;
}

export const GrossAreaQuestion = ({
  formProps,
  productText,
  lang,
}: Props): React.ReactElement => {
  return (
    <>
      <Input
        name="grossArea"
        id="grossArea"
        hint={productText.grossArea.hint[lang]}
        label={productText.grossArea.label[lang]}
        error={getError("grossArea", formProps)}
        type="number"
        large
        inputMode={InputMode.NUMERIC}
      />
      {isGrossAreaInvalid(formProps.values.grossArea) && (
        <WrapMdMarginBottom>
          <ContactUsAlert
            description={productText.grossArea.validation[lang]}
            title={productText.alertTitle[lang]}
            alertId="grossArea"
          />
        </WrapMdMarginBottom>
      )}
    </>
  );
};
